import React from "react";
import theme from "@/theme";
import { useMediaQuery } from "@mui/material";
import { usePdpProduct } from "@/features/pdp/PdpContext";
import { CoverImage } from "@/components/CoverImage";

export const HoverSwapGallery = () => {
  const product = usePdpProduct();
  const media = product.media || [];

  const baseImage = media.find((m) => m.mediaType === "image");

  const altImage = media.find(
    (m) =>
      m.mediaType === "image" &&
      m.altText &&
      m.altText.toLowerCase().includes("alternative")
  );

  const isSmallScreen = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );

  if (!baseImage) return null;

  if (!altImage || isSmallScreen) {
    return (
      <CoverImage
        src={baseImage.url}
        alt={baseImage.alt ?? product.title}
        width={baseImage.width ?? undefined}
        height={baseImage.height ?? undefined}
        loading={"eager"}
      />
    );
  }

  return (
    <div className="group relative h-full w-full">
      <div className="block h-full w-full group-hover:hidden">
        <CoverImage
          src={baseImage.url}
          alt={baseImage.alt ?? product.title}
          width={baseImage.width ?? undefined}
          height={baseImage.height ?? undefined}
          loading={"eager"}
        />
      </div>

      <div className="inset-0 z-10 hidden h-full w-full group-hover:block">
        <CoverImage
          src={altImage.url}
          alt={altImage.alt ?? product.title}
          width={altImage.width ?? undefined}
          height={altImage.height ?? undefined}
          loading={"eager"}
        />
      </div>
    </div>
  );
};
